export default function ComparisonSection() {
  const comparisons = [
    {
      platform: 'Hipobuy Spreadsheet',
      strength: 'Comprehensive category coverage with 14 distinct product segments',
      categoryCoverage: '★★★★★',
      beginnerFriendly: '★★★★★',
      updateFrequency: 'Weekly',
      accent: true,
    },
    {
      platform: 'Kakobuy Spreadsheet',
      strength: 'Strong focus on fashion and streetwear categories',
      categoryCoverage: '★★★★☆',
      beginnerFriendly: '★★★★☆',
      updateFrequency: 'Bi-weekly',
      accent: false,
    },
    {
      platform: 'CSSBuy Spreadsheet',
      strength: 'Well-established platform with extensive community resources',
      categoryCoverage: '★★★★☆',
      beginnerFriendly: '★★★☆☆',
      updateFrequency: 'Monthly',
      accent: false,
    },
    {
      platform: 'Superbuy Spreadsheet',
      strength: 'Broad international shipping and logistics integration',
      categoryCoverage: '★★★☆☆',
      beginnerFriendly: '★★★★☆',
      updateFrequency: 'Bi-weekly',
      accent: false,
    },
    {
      platform: 'Oopbuy Spreadsheet',
      strength: 'Growing platform with competitive pricing structures',
      categoryCoverage: '★★★☆☆',
      beginnerFriendly: '★★★☆☆',
      updateFrequency: 'Monthly',
      accent: false,
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-primary-600 mb-3">
            / Platform Comparison
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Hipobuy Spreadsheet vs Other Platforms
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-2xl mx-auto">
            See how Hipobuy Spreadsheet compares to other popular spreadsheet platforms across key metrics that matter most to shoppers.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="text-left py-4 px-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Platform</th>
                <th className="text-left py-4 px-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Strength</th>
                <th className="text-center py-4 px-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Category Coverage</th>
                <th className="text-center py-4 px-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Beginner Friendly</th>
                <th className="text-center py-4 px-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Update Frequency</th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((item) => (
                <tr
                  key={item.platform}
                  className={`border-b border-background-200/70 ${
                    item.accent ? 'bg-primary-50/40' : 'hover:bg-background-100/50'
                  } transition-colors`}
                >
                  <td className={`py-4 px-4 font-heading font-semibold whitespace-nowrap ${
                    item.accent ? 'text-primary-700' : 'text-foreground-900'
                  }`}>
                    {item.platform}
                  </td>
                  <td className="py-4 px-4 text-foreground-700 leading-relaxed max-w-xs">
                    {item.strength}
                  </td>
                  <td className="py-4 px-4 text-center text-xs text-foreground-600 whitespace-nowrap">
                    {item.categoryCoverage}
                  </td>
                  <td className="py-4 px-4 text-center text-xs text-foreground-600 whitespace-nowrap">
                    {item.beginnerFriendly}
                  </td>
                  <td className="py-4 px-4 text-center whitespace-nowrap">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                      item.updateFrequency === 'Weekly'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.updateFrequency}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}